import { render, staticRenderFns } from "./Honor.vue?vue&type=template&id=56bcdb10&scoped=true"
import script from "./Honor.vue?vue&type=script&lang=js"
export * from "./Honor.vue?vue&type=script&lang=js"
import style0 from "./Honor.vue?vue&type=style&index=0&id=56bcdb10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bcdb10",
  null
  
)

export default component.exports